module.exports = __webpack_public_path__ + "static_pest_wiki_details/img/paidui_infobanner03.62ceb64.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pc/product_info/paidui_infobanner03.png
// module id = O4Ob
// module chunks = 0